import _ from "lodash";

/**
 * 全角数字を半角数字に変換するクラス
 */
export default class HalfNumbersConverter {
  public convert(text: string) {
    return text.replace(this.conversionRegExp, m => this.convertCharacter(m));
  }

  private keys = [
    "０",
    "１",
    "２",
    "３",
    "４",
    "５",
    "６",
    "７",
    "８",
    "９",
    "。"
  ];
  private values = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."];

  private get conversionMap(): Map<string, string> {
    return new Map(_.zip(this.keys, this.values) as [string, string][]);
  }

  private get conversionRegExp(): RegExp {
    return new RegExp(`(${this.keys.join("|")})`, "g");
  }

  private convertCharacter(key: string) {
    return this.conversionMap.get(key) || "";
  }
}
